import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAnime from './utils/anime-vue'
import VueFullPage from 'vue-fullpage.js'
import VueMeta from 'vue-meta'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnime)
Vue.use(VueFullPage)
Vue.use(VueMeta)

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-154734818-1',
  router
})

new Vue({
  router,
  store,
  created () {
    if (window.location.hostname === 'thebearandhisscarf.com') {
      this.$store.commit('setLanguage', { lang: 'en' })
    } else if (window.location.hostname === 'loursetsonecharpe.be' || window.location.hostname === 'club-brugge-fr') {
      this.$store.commit('setLanguage', { lang: 'fr' })
    } else {
      if (this.$route.params.lang !== undefined) {
        this.$store.commit('setLanguage', { lang: this.$route.params.lang })
      } else {
        this.$store.commit('setLanguage', { lang: 'nl' })
      }
    }

    this.cssVar()
    this.checkWebp()
    window.addEventListener('resize', this.cssVar)

    window.onbeforeunload = () => {
      window.scrollTo(0, 0)
    }
  },
  methods: {
    cssVar () {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    },

    async supportsWebp () {
      if (!self.createImageBitmap) return false

      const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
      const blob = await fetch(webpData).then(r => r.blob())
      return createImageBitmap(blob).then(() => true, () => false)
    },

    async checkWebp () {
      if (await this.supportsWebp()) {
        this.$store.commit('setWebP', { result: true })
      } else {
        this.$store.commit('setWebP', { result: false })
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
